import React, { useState } from "react";
import axios from "axios";
import { Loading } from "@/pages/Other/Loading";

function Courses() {
    const [courseName, setName] = useState("");
    const [description, setJob] = useState("");
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [data, setData] = useState(null);

    const handleSubmit = async () => {
        setLoading(true);
        setIsError(false);

        const data = {
            courseName: courseName,
            description: description,
        };

        try {
            const res = await axios.post("https://backend-linux-login.azurewebsites.net/course", data);
            setData(res.data);
            setName("");
            setJob("");
            setLoading(false);
        } catch (err) {
            setLoading(false);
            setIsError(true);
            console.error("Error submitting course:", err);
        }
    };


    return (
        <div>
            <div>
                <div className="form-group">
                    <label htmlFor="courseName">Name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="courseName"
                        placeholder="Enter Course name"
                        value={courseName}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="description" className="mt-2">
                        description
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="description"
                        placeholder="Enter description"
                        value={description}
                        onChange={(e) => setJob(e.target.value)}
                    />
                </div>
                {isError && (
                    <small className="mt-3 d-inline-block text-danger">
                        Something went wrong. Please try again later.
                    </small>
                )}
                <button
                    type="submit"
                    className="btn btn-primary mt-3"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? <Loading/> : "Submit"}
                </button>
            </div>
        </div>
    );
}

export default Courses;
{
    /** import React, { useState } from "react";
  import OptionsComponent from "../../assets/optionsComponent/OptionsComponent";
  
  import { useTranslation } from "react-i18next";
  //import i18n from "../../utils/i18n/i18n";
  
  import "./courses.css";
  
  export default function Courses() {
      // const [filter, setFilter] = useState();
      const [expandItem, setExpandItem] = useState();
      const [label, setLabel] = useState("Filter");
  
      const def = [
          {
              key: 0,
              title: "Java Programming Masterclass for Software Development",
              label: "Java",
              instructorName: "Fredrich Alexionas",
              avatarImg: "https://www.w3schools.com/howto/img_avatar.png",
              description: "Programming language",
              duration: "80 Hrs",
              category: "Programming",
              status: 48,
              showExpansion: false,
          },
          {
              key: 1,
              title: "Programming Basics with Python",
              label: "Python",
              instructorName: "Marteen Perhiniak",
              avatarImg: "https://www.w3schools.com/howto/img_avatar2.png",
              description: "Programming language",
              duration: "20 Hrs",
              category: "Programming",
              status: 100,
              showExpansion: false,
          },
          {
              key: 2,
              title: "Complete Interactive guide to NodeJS Development",
              label: "NodeJS",
              instructorName: "Vladimir Kervyav",
              avatarImg: "https://www.w3schools.com/howto/.png",
              description: "Programming language",
              duration: "10 Hrs",
              category: "Web Development",
              status: 0,
              showExpansion: false,
          },
          {
              key: 3,
              title: "Javascript the very easy way for optimal Development",
              label: "Javascript",
              instructorName: "Ravish Mittal",
              avatarImg: "https://www.w3schools.com/w3images/avatar2.png",
              description: "Programming language",
              category: "Web Development",
              duration: "30 Hrs",
              status: 24,
              showExpansion: false,
          },
          {
              key: 4,
              title: "The Complete Ruby on Rails Developer Course",
              label: "Ruby",
              instructorName: "Shikha Kapoor",
              avatarImg: "https://www.w3schools.com/w3images/avatar6.png",
              description: "Programming language",
              category: "Programming",
              duration: "30 Hrs",
              status: 41,
              showExpansion: false,
          },
          {
              key: 5,
              title: "The Complete C Programming Bootcamp",
              label: "C",
              instructorName: "Dr. Jian Huang Cho",
              avatarImg: "https://www.w3schools.com/w3images/avatar5.png",
              description: "Programming language",
              category: "Programming",
              duration: "120 Hrs",
              status: 15,
              showExpansion: false,
          },
          {
              key: 6,
              title: "The Complete C++ Programming Bootcamp",
              label: "C++",
              instructorName: "Charles Hu",
              avatarImg: "https://www.w3schools.com/howto/img_avatar.png",
              description: "Programming language",
              category: "Programming",
              duration: "90 Hrs",
              status: 10,
              showExpansion: false,
          },
          {
              key: 7,
              title: "The Complete C# Programming Bootcamp",
              label: "C#",
              instructorName: "Peter Navarro",
              avatarImg: "https://www.w3schools.com/howto/img_avatar.png",
              description: "Programming language",
              duration: "80 Hrs",
              category: "Programming",
              status: 2,
              showExpansion: false,
          },
          {
              key: 8,
              title: "The Complete HTML5 Guide to interactive and accessible content development",
              label: "HTML5",
              instructorName: "Louay Larry Zambarakji",
              avatarImg: "https://www.w3schools.com/howto/img_avatar.png",
              description: "Other ",
              duration: "08 Hrs",
              category: "Web Design",
              status: 92,
              showExpansion: false,
          },
          {
              key: 9,
              title: "Build Responsive Real World Websites with CSS3(and HTML5)",
              label: "CSS",
              instructorName: "Stefan Emilio Sanchez",
              avatarImg: "https://www.w3schools.com/howto/img_avatar.png",
              description: "other",
              duration: "10 Hrs",
              category: "Web Design",
              status: 90,
              showExpansion: false,
          },
          {
              key: 10,
              title: "Ultimate Adobe Photoshop Training: From Beginner to Pro",
              label: "Adobe Photoshop",
              instructorName: "Broderrick Mitchell",
              avatarImg: "https://www.w3schools.com/howto/img_avatar.png",
              description: "Graphic Design",
              duration: "05 Hrs",
              category: "Graphic Design",
              status: 100,
              showExpansion: false,
          },
          {
              key: 11,
              title: "Adobe Illustrator 2021 MasterClass",
              label: "Adobe Illustrator",
              instructorName:
                  "Video Editing School, Scott Ebiner, Dan Walter Schmidt",
              avatarImg: "https://www.w3schools.com/howto/img_avatar2.png",
              description: "Graphic Design",
              duration: "15 Hrs",
              category: "Graphic Design",
              status: 0,
              showExpansion: false,
          },
      ];
  
      const [coursesList, setCourseList] = useState(def);
      const { t } = useTranslation();
      const statusOpt = [
          {
              key: 0,
              label: t("status.ns"),
              value: 0,
              icon: "icon-grey",
          },
          {
              key: 1,
              label: t("status.st"),
              value: 50,
              icon: "icon-green",
          },
          {
              key: 2,
              label: t("status.co"),
              value: 100,
              icon: "icon-red",
          },
      ];
  
      function setFiltersVal(abc) {
          setCourseList(() => {
              let a = [];
              if (abc === 0) {
                  def.map((item) => {
                      return item.status === 0 ? a.push(item) : null;
                  });
              }
              if (abc === 50) {
                  def.map((item) => {
                      return item.status !== 0 && item.status !== 100
                          ? a.push(item)
                          : null;
                  });
              }
              if (abc === 100) {
                  def.map((item) => {
                      return item.status === 100 ? a.push(item) : null;
                  });
              }
              setLabel(
                  abc === 0
                      ? statusOpt[0].label
                      : abc === 100
                      ? statusOpt[2].label
                      : statusOpt[1].label,
              );
              return a;
          });
      }
  
      return (
          //For whole page
          <section className='container-wrapper b'>
              <div className='sort-wrapper'>
                  <div className='filter-label'>{t("status.filterStatus")}</div>
  
                  <OptionsComponent
                      name={label}
                      listsa={statusOpt}
                      setValue={setFiltersVal}
                  />
  
                  <div
                      className='btn'
                      onClick={() => {
                          setCourseList(def);
                      }}>
                      <span>&times; {t("status.caf")}</span>
                  </div>
                  <div className='btn'>
                      <a href='/add-course'>{t("status.addCourse")}</a>
                  </div>
              </div>
  
              <div className='grid'>
                  /* if default view is on then render default view 
  
                  {coursesList.map((item) => {
                      return (
                          <div
                              data-aos='flip-down'
                              data-aos-once='true'
                              key={item.key}
                              className='box'>
                              <div className='flex-wrapper spread-evenly'>
                                  <div
                                      className='title'
                                      onClick={() => {
                                          item["showExpansion"] =
                                              item.showExpansion ? false : true;
                                          setExpandItem(
                                              item.showExpansion ? item : null,
                                          );
                                      }}>
                                      <a href='#S'>{item.title}</a>
                                  </div>
  
                                  <div className='instructor-name'>
                                      {item.instructorName}
                                  </div>
  
                                  <div>{item.duration}</div>
  
                                  <div>{t("status.ns")}</div>
  
                                  <div className='percent'>{item.status}</div>
  
                                  {/*
                              <div className='course-label'>{item.label}</div>
                             
  
                                  <div>{item.description}</div>
                              </div>
  
                              <div className='button-wrapper'>
                                  <div
                                      className='btn btn-enroll'
                                      onClick={() => {
                                          item["showExpansion"] =
                                              item.showExpansion ? false : true;
                                          setExpandItem(
                                              item.showExpansion ? item : null,
                                          );
                                      }}>
                                      <a href='#S'>More Info</a>
                                  </div>
  
                                  <div className='btn'>View Content</div>
                                  <div className='btn'>Course Outline</div>
                              </div>
  
                              <div
                                  className={
                                      expandItem ? "expanded-view" : "hide"
                                  }>
                                  {expandItem === item ? (
                                      <div className='flush-flush'>
                                          <div className='title'>
                                              {item.title}
                                          </div>
  
                                          <div className='course-duration'>
                                              {item.duration}
                                          </div>
  
                                          <div className='flex-wrapper'>
                                              <div className='title-label'>
                                                  {t("status.courseProgress")}
                                              </div>
  
                                              {/*
                                               <div className="sub-title">
  
                                               </div>
                                               
  
                                              <div className='status-wrapper'>
                                                  <div
                                                      className='status-bar'
                                                      style={{
                                                          width:
                                                              item.status + "%",
                                                      }}></div>
                                              </div>
  
                                              <div className='percent'>
                                                  {item.status}
                                              </div>
                                          </div>
  
                                          <p className='instructor-name'>
                                              {item.instructorName}
                                          </p>
  
                                          <div className='avatar-image large'>
                                              <img
                                                  alt='Avatar '
                                                  src={item.avatarImg}
                                              />
                                          </div>
                                      </div>
                                  ) : null}
                              </div>
                          </div>
                      );
                  })}
              </div>
          </section>
      );
  }
  */
}
